// @ts-check
import React from 'react';
import { Link as GatsbyLink } from 'gatsby';

/**
 * @typedef LinkProps
 * @property {string} to
 * @property {boolean} [openInNewTab=false]
 */
/** @type {import('~/types/React').ReactFC<LinkProps & import('react').AnchorHTMLAttributes>} */
const Link = ({ children, to, openInNewTab = false, ...other }) => {
	const aTagUrlPrefixes = ['http', '/static', '/disclosures/certificates-of-deposit/', 'tel:', 'mailto:'];
	const isExternal = aTagUrlPrefixes.some((p) => typeof to === 'string' && to?.startsWith(p));

	// We only want to use a GatsbyLink if it's linking to another Gatsby Page.
	if (!isExternal) {
		if (to?.indexOf('#') < 0 && to?.indexOf('?') < 0 && !to?.trim().endsWith('/')) {
			to = to.trim() + '/';
		}

		return (
			<GatsbyLink to={to} {...other} rel="noreferrer">
				{children}
			</GatsbyLink>
		);
	}

	// A-tag elsewhere - this allows external and `mailto:` links, etc.
	return (
		// DO NOT modify to make all links open in new tab
		// --there are links where we want to stay (like logins)
		<a href={to} rel="noreferrer" target={openInNewTab ? '_blank' : '_self'} {...other}>
			{children}
		</a>
	);
};

export default Link;
